module.exports = __webpack_public_path__ + "static/media/profile_night.8240d828.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/screens/profile_night.gif
// module id = 708
// module chunks = 0